import { useEffect } from 'react';

const scroll = {
  container: '#___gatsby',
  options: {
    smooth: true,
    smoothMobile: false,
    getDirection: true,
    touchMultiplier: 2.5,
    lerp: 0.08,
  },
};

const SmoothScroll = ({ callbacks }) => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    let locomotiveScroll;
    let onScroll;
    let isMounted = true;

    const initScroll = async () => {
      const { default: LocomotiveScroll } = await import('locomotive-scroll');
      if (!isMounted) return;

      const container = document.querySelector(scroll.container);
      if (!container) return;

      locomotiveScroll = new LocomotiveScroll({
        el: container,
        ...scroll.options,
      });

      // Keep compatibility with existing components using `window.scroll`.
      window.scroll = locomotiveScroll;

      onScroll = func => {
        document.documentElement.setAttribute('data-direction', func.direction || 'down');
      };

      locomotiveScroll.on('scroll', onScroll);
      locomotiveScroll.update();
    };

    initScroll();

    return () => {
      isMounted = false;

      if (locomotiveScroll && onScroll && typeof locomotiveScroll.off === 'function') {
        locomotiveScroll.off('scroll', onScroll);
      }

      if (locomotiveScroll) {
        locomotiveScroll.destroy();
      }

      if (typeof window !== 'undefined' && window.scroll === locomotiveScroll) {
        delete window.scroll;
      }
    };
  }, [callbacks]);

  return null;
};

export default SmoothScroll;
